import React, {useImperativeHandle, useRef, useState } from "react";
import { Button, Input, Selector } from "../Elements";
import Modal from "../Modal";
import { getSendOptionById, sendOptions, sendTypeIds } from "../../../constants/options/sendOptions";
import { getExpireDateById, paymentLinkDates } from "../../../constants/options/linkExpireDates";
import { controlPaymentLinkPackages } from '../../../common/helpers/packagesHelper';
import { toast } from "react-toastify";
import commonNetwork from "../../../common/api/commonNetwork";
import PaymentLinkResultModal from "../PaymentLinkResultModal";
import { isValidEmailAddress, isValidPhoneNumber } from "../../../common/helpers/globalHelpers";
import { formatCurrency } from "../../../lib/helpers";
import appHelpers from "../../../common/helpers/appHelpers";


const ReSendLinkModal = React.forwardRef((props, ref) => {

    const linResultModalRef = useRef();
    const [isModalVisible, setIsModalVisible] = useState(false); 
    const [statusModalVisible, setStatusModalVisible] = React.useState(false);
    const isDemoUser = appHelpers.isDemoUser();
    const [fields, setFields] = useState({
        amount: 0,
        sendtype: 3,
        phone: "",
        email: "",
        lastlinkdate: 4,
        customerName: "",
        customerCode: "",
        paymentLinkId: -1
    });
    const [createLoading, setCreateLoading] = useState(false);

    useImperativeHandle(ref, () => ({
        openModal(defaultValues) {
            setFields(defaultValues);
            setIsModalVisible(true);
            setCreateLoading(false);
        }
    }));

    const onUpdateClick = async () => {
        if (isDemoUser) {
            toast.error("Demo kullanımında sadece Serbest Ödeme ekranı üzerinden ödeme linki oluşturabilirsiniz.");
      
            return;
          }

        setCreateLoading(true);
        var smsCount = 0, emailCount = 0, whatsappCount = 0;
        if (fields.sendtype == sendTypeIds.sms) {
            smsCount++;
        } else if (fields.sendtype == sendTypeIds.email) {
            emailCount++;
        } else if (fields.sendtype == sendTypeIds.whatsapp) {
            whatsappCount++;
        } else {
            emailCount++;
            smsCount++;
        }

        const packageResult = await controlPaymentLinkPackages(smsCount, emailCount, whatsappCount);
        if (packageResult.serviceError != true) {
            const { isMailOverflow, isSmsOverflow, mailOverflowCount, smsOverflowCount, isWhatsappOverflow } = packageResult;
            if (isMailOverflow || isSmsOverflow || isWhatsappOverflow) {
                toast.error("SMS/Email/Whatsapp paketiniz tükenmiştir. Ödeme linki oluşturmak için SMS/E-mail/Whatsapp paketi satın almanız gerekmektedir.");
            } else {
                var amount = formatCurrency(fields.amount);
                const params = {
                    amount: amount,
                    sendtype: fields.sendtype,
                    phone: fields.phone,
                    email: fields.email,
                    customerName: fields.customerName,
                    customerCode: fields.customerCode,
                    lastlinkdate: fields.lastlinkdate || 4,
                    paymentLinkId: fields.paymentLinkId
                }
                postPaymentLinksAfterControl(params);
            }
        } else {
            toast.error(packageResult.errorMessage);
        }
    }

    const postPaymentLinksAfterControl = async (formData) => {

        const response = await commonNetwork.post("/payment-link-from-previous", formData);
        const { isSuccess, data, errorMessage } = response;
        setCreateLoading(false);

        if (isSuccess) {
            setIsModalVisible(false);
            const errorList = [], successList = [{
                id: 1
            }];
            linResultModalRef.current.showMessage(errorList, successList);
            setStatusModalVisible(true);
        } else {
            toast.error(errorMessage);
        }
    }

    const onChangeField = (event) => {
        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }

    const onChangeSelectField = (name, value) => {
        setFields({
            ...fields,
            [name]: value
        });
    }

    const isValidPhone = () => {
        if (fields.phone) {
            var phoneStatus = isValidPhoneNumber(fields.phone);
            if (phoneStatus) {
                return "";
            } else {
                if (fields.sendtype == 1 || fields.sendtype == 3) {
                    return "Lütfen telefon numarasını doğru formatta giriniz.";
                }
            }
        } else {
            return false;
        }
    }

    const isValidEmail = () => {
        if (fields.email) {
            var mailStatus = isValidEmailAddress(fields.email);
            if (mailStatus) {
                return "";
            } else {
                if (fields.sendtype == 2 || fields.sendtype == 3) {
                    return "Lütfen Email adresini doğru formatta giriniz.";
                }
            }
        } else {
            return "";
        }
    }
 
    return (
        <>
            <PaymentLinkResultModal ref={linResultModalRef} statusModalVisible={statusModalVisible} setStatusModalVisible={setStatusModalVisible}></PaymentLinkResultModal>
            <Modal openModal={isModalVisible} setOpenModal={() => setIsModalVisible(false)} >
                <div>
                    <div className="sm:flex sm:items-start">
                        <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-[100%]">
                            <h3 className="text-md leading-6 font-medium text-gray-900">
                                {fields.customername} Düzenle Ve Tekrar Gönder
                            </h3>
                            <div className="flex w-100">
                                <div className="flex-auto w-50">

                                    <div className="mt-4">
                                        <Selector
                                            options={sendOptions}
                                            name={`sendtype`}
                                            defaultValue={getSendOptionById(fields.sendtype || 3)}
                                            className="w-[100%]"
                                            label="Gönderim Şekli"
                                            menuPortalTarget={document.body}
                                            onChange={({ value }) => onChangeSelectField("sendtype", value)}
                                            required
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Input
                                            name={`email`}
                                            value={fields.email}
                                            type="text"
                                            className="w-[100%]"
                                            label="Email"
                                            onChange={onChangeField}
                                            required
                                            error={isValidEmail()}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Input
                                            name={`phone`}
                                            value={fields.phone}
                                            type="text"
                                            className="w-[100%]"
                                            label="Telefon"
                                            onChange={onChangeField}
                                            required
                                            error={isValidPhone()}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Input
                                            name={`amount`}
                                            value={fields.amount}
                                            className="w-[100%]"
                                            label="Ödeme Talep Bakiyesi"
                                            onChange={onChangeField}
                                            required
                                            currencyformat="true"
                                            currencyicon="true"
                                            defaultValue="0.00"
                                            isTRCurrencyDisplay={true}
                                        />
                                    </div>
                                    <div className="mt-4">
                                        <Selector
                                            options={paymentLinkDates}
                                            name={`lastlinkdate`}
                                            defaultValue={getExpireDateById(fields.lastlinkdate || 4)}
                                            className="w-[100%]"
                                            label="Link Geçerlilik Süresi"
                                            menuPortalTarget={document.body}
                                            onChange={({ value }) => onChangeSelectField("lastlinkdate", value)}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mt-4 flex justify-end space-x-2">
                        <Button
                            color="gray"
                            hover="gray"
                            size="xs"
                            callback={() => setIsModalVisible(false)}
                        >
                            İptal
                        </Button>
                        <Button
                            color="primary"
                            hover="primary"
                            size="xs"
                            loading={createLoading}
                            disabled={createLoading}
                            callback={() => {
                                onUpdateClick();
                            }}
                        >
                            Gönder
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    );
})

export default ReSendLinkModal;